import * as XLSX from 'xlsx';
import axios from 'axios';
import moment from 'moment';

export const generateExcel = async (date, apiEndpoint) => {
  try {
    const response = await axios.get(apiEndpoint, {
      params: { date }
    });
    let { data, headers, title } = response.data;

    // Process data - remove first element of each row
    data = data.map((row) => {
      row.shift();
      
      if (row.length > 0 && typeof row[0] === 'string') {
        row[0] = row[0].replace(/\s+/g, ' ').trim();
      }
      return row;
    });

    // Create workbook and worksheet
    const workbook = XLSX.utils.book_new();
    
    // Create header data
    const headerData = [
      ['IDEAL PRECISION COMPONENTS Pvt. Ltd.'],
      [title],
      headers,
      ...data
    ];

    // Create worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(headerData);

    // Set column widths
    const colWidths = headers.map((header, index) => ({
      wch: index === 0 ? 30 : 15
    }));
    worksheet['!cols'] = colWidths;

    // Set row heights
    worksheet['!rows'] = [
      { hpt: 60 }, // First row height
      { hpt: 20 }, // Second row height
      { hpt: 20 }  // Header row height
    ];

    // Style the cells (basic styling with xlsx)
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    
    // Style header cells
    for (let col = range.s.c; col <= range.e.c; col++) {
      const headerCell = worksheet[XLSX.utils.encode_cell({ r: 2, c: col })];
      if (headerCell) {
        headerCell.s = {
          font: { bold: true },
          fill: { fgColor: { rgb: "DDDDDD" } },
          alignment: { horizontal: "center", vertical: "center" }
        };
      }
    }

    // Style title cells
    const titleCell1 = worksheet[XLSX.utils.encode_cell({ r: 0, c: 0 })];
    if (titleCell1) {
      titleCell1.s = {
        font: { bold: true, sz: 16 },
        alignment: { horizontal: "center", vertical: "center" }
      };
    }

    const titleCell2 = worksheet[XLSX.utils.encode_cell({ r: 1, c: 0 })];
    if (titleCell2) {
      titleCell2.s = {
        font: { bold: true, sz: 14, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "000000" } },
        alignment: { horizontal: "center", vertical: "center" }
      };
    }

    // Merge cells for headers
    worksheet['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } }
    ];

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

    // Generate and download file
    const fileName = `${title} ${moment(date).format('MMMM_YYYY')}.xlsx`;
    XLSX.writeFile(workbook, fileName);

  } catch (error) {
    console.error('Error generating Excel:', error);
  }
};